
import Vue from 'vue'
import App from './App.vue'
import router from './router';
import VueGtm from '@gtm-support/vue2-gtm'

Vue.config.productionTip = false

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID || 'GTM-K5VRMDV7',
  vueRouter: router,
  trackView: true,
  loadScript: true,
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


